/**
 * Forgot Password
 */
import { useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import FormControl from '@mui/material/FormControl';
import { Link as RouterLink } from 'react-router-dom';
import Button from '../../components/Button';
import AuthLayout from '../../components/AuthLayout/AuthLayout';
import { ROUTES } from '../../constants/routes';
import api from '../../services/api';
import { FORGOT_PASSWORD } from '../../constants/api';
import { validateEmail } from '../../constants/utils';

function ForgotPassword() {
  const [formData, setFormData] = useState({});
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [showInfo, setShowInfo] = useState(null);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  async function forgotPassword(data) {
    try {
      const response = await api.post(FORGOT_PASSWORD, data);
      response.data.data.status.toLowerCase() === 'success' && response.data.success
        ? setShowInfo('success')
        : setShowInfo('failed');
    } catch (error) {
      console.error(error);
      setShowInfo('failed');
    }
  }

  function validateCredentials() {
    if (validateEmail(formData.username)) {
      setApiCallInProgress(true);
      forgotPassword(formData);
    }
  }
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toLowerCase(),
    }));
    name && value && setSubmitDisabled(false);
  };

  return (
    <AuthLayout title={'Forgot Password'}>
      {showInfo === null ? (
        <>
          <Typography style={{ margin: '15px' }}>
            Don't worry, we are here to help. Just enter your email below and we would send you an
            email about the details on resetting the password.
          </Typography>
          <FormControl fullWidth={true}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={handleInputChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ margin: '24px 0 16px' }}
              onClick={validateCredentials}
              disabled={submitDisabled}
            >
              {apiCallInProgress ? (
                <CircularProgress size={24} color="secondary" />
              ) : (
                'SEND ME EMAIL'
              )}
            </Button>
            <Typography variant="body2"></Typography>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link component={RouterLink} to={ROUTES.login} variant="body2">
                  Know your password ? Login
                </Link>
              </Grid>
            </Grid>
          </FormControl>
        </>
      ) : showInfo === 'success' ? (
        <Typography>
          An email has been sent to you with an reset link. Please click on the link to reset your
          password.
        </Typography>
      ) : (
        <Typography variant="body2" textAlign="center" sx={{ margin: '16px 0' }} color="error">
          Please try again or contact support.
        </Typography>
      )}
    </AuthLayout>
  );
}

export default ForgotPassword;
